import { __rest } from '../../_virtual/_tslib.js';
import React__default, { useState, useEffect } from 'react';
import Pagination from 'reactstrap/lib/Pagination';
import PaginationItem from 'reactstrap/lib/PaginationItem';
import PaginationLink from 'reactstrap/lib/PaginationLink';
import { ReactComponent as SvgAngleRight } from '../../icons/AngleRight.svg.js';
import { ReactComponent as SvgAngleLeft } from '../../icons/AngleLeft.svg.js';
import { ReactComponent as SvgAngleRightGray } from '../../icons/AngleRightGray.svg.js';
import { ReactComponent as SvgAngleLeftGray } from '../../icons/AngleLeftGray.svg.js';
import { getRemValue } from '../../methods/getRemValue.js';
import '../../constants/authorizedUsers.js';
import '../../constants/bidStatus.js';
import '../../constants/bulkLoadCardStatus.js';
import '../../constants/misc.js';
import '../../constants/event-names.js';
import '../../constants/eventsMapObj.js';
import '../../constants/Faq.js';
import '../../constants/languages.js';
import '../../constants/loadStatus.js';
import '../../constants/lorryStatus.js';
import '../../constants/lorryTypes.js';
import '../../constants/mostSearchedLinks.js';
import '../../constants/Pages.js';
import '../../constants/serviceTypeId.js';
import '../../constants/StateList.js';
import '../../constants/bidUpdateType.js';
import '../../constants/userAction.js';
import '../../constants/api.js';
import '../../constants/link.js';
import '../../constants/market.js';
import '../../constants/payment.js';
import '../../constants/admin/screenId.js';
import '../../_services/const.js';
import 'bowser';
import '../toast/toast.js';
import '../../_services/auth.service.js';
import '../../methods/getAuthIdParam.js';
import 'react-cookie';
import '../../methods/formatDate.js';
import '../../methods/getTransporterFigure.js';
import '../../methods/getDownloadsFigure.js';
import 'lodash.isequal';
import '../../methods/getPageLoadSourceUTMParam.js';
import 'crypto-js';

// let pageLimit = 10; // number of page links in pagination
const Bottompagination = ({ currentPage, pagesCount, handleClick, isMobile, PrevLink, NextLink, PageLink }) => {
    PrevLink = (PrevLink || ((_a) => {
        var props = __rest(_a, ["pageNum"]);
        return React__default.createElement("div", Object.assign({}, props));
    }));
    NextLink = (NextLink || ((_a) => {
        var props = __rest(_a, ["pageNum"]);
        return React__default.createElement("div", Object.assign({}, props));
    }));
    PageLink = (PageLink || ((_a) => {
        var props = __rest(_a, ["pageNum"]);
        return React__default.createElement("div", Object.assign({}, props));
    }));
    const [start, setStart] = useState(0);
    const [end, setEnd] = useState(6);
    const [pageLimit, setPageLimit] = useState(6);
    const onClickPrev = (e) => {
        if (!handleClick) {
            return;
        }
        e.preventDefault();
        handleClick(currentPage - 1);
    };
    const onClickPage = (e, page) => {
        if (!handleClick) {
            return;
        }
        e.preventDefault();
        handleClick(page);
    };
    const onClickNext = (e) => {
        if (!handleClick) {
            return;
        }
        e.preventDefault();
        handleClick(currentPage + 1);
    };
    useEffect(() => {
        // let start = 0; // starting page
        // let end = pageLimit; // ending page
        // console.log("pageLimit",pageLimit)
        if (pagesCount <= pageLimit) {
            setPageLimit(pagesCount);
        }
        if (pagesCount >= 1) {
            // if (pagesCount <= pageLimit) {
            //     setPageLimit(pagesCount);
            // }
            // increment start page when current page is greater than 5
            if (currentPage >= 3) {
                setStart(currentPage - 2);
            }
            // if reaching end of pagination stop increment
            if (start + pageLimit >= pagesCount) {
                setStart(pagesCount - pageLimit);
            }
            if (end - start >= 6) {
                setEnd(currentPage + 4);
                setStart(currentPage - 2);
            }
            // if(end - currentPage ){
            //     setStart(end  - 10)
            // }
            // increment end page when current + 5 exceeds page limit
            if (start + end >= pageLimit) {
                setEnd(currentPage + 4);
                setPageLimit(currentPage + 4);
                if (pagesCount <= currentPage + 4) {
                    setPageLimit(pagesCount);
                }
            }
        }
    }, [currentPage, pagesCount]);
    return (React__default.createElement(Pagination, { "aria-label": "Page navigation example", style: {
        /* display: "flex", alignItems: "center" */
        } },
        React__default.createElement(PaginationItem, { disabled: currentPage === 1, style: {
                border: "none",
                outline: "none",
                background: "white",
                marginRight: isMobile ? "2px" : "8px"
            } },
            React__default.createElement(PrevLink, null,
                React__default.createElement(PaginationLink, { onClick: onClickPrev, previous: true, style: { border: "none", outline: "none", boxShadow: "none" } }, currentPage === 1 ? (React__default.createElement("div", { style: {
                        height: isMobile ? "8px" : "12px",
                        width: isMobile ? "4.10px" : "6.91px",
                        alignItems: "center"
                    }, id: "navigate-prev" },
                    React__default.createElement(SvgAngleRightGray, null))) : (React__default.createElement("div", { style: {
                        height: isMobile ? "8px" : "12px",
                        width: isMobile ? "4.6px" : "6.91px",
                        alignItems: "center"
                    }, id: "navigate-prev" },
                    React__default.createElement(SvgAngleRight, null)))))),
        [...Array(pageLimit)].map((page, i) => {
            if (i >= start && i < end) {
                return (React__default.createElement(PaginationItem, { active: i + 1 === currentPage, key: i, style: {
                        width: isMobile ? "unset" : "36px",
                        outline: "none",
                        marginLeft: isMobile ? "2px" : "4px",
                        marginRight: isMobile ? "2px" : "4px"
                    } },
                    React__default.createElement(PageLink, { pageNum: i + 1 },
                        React__default.createElement(PaginationLink, { style: i + 1 === currentPage
                                ? {
                                    borderRadius: "50%",
                                    borderColor: "#222222",
                                    background: "#222222",
                                    height: isMobile ? "unset" : "36px",
                                    width: isMobile ? "unset" : "36px",
                                    opacity: "1",
                                    outline: "none",
                                    fontSize: isMobile ? getRemValue(10) : getRemValue(14),
                                    letterSpacing: isMobile ? getRemValue(0.1) : getRemValue(0.16),
                                    boxShadow: "none"
                                    //   marginLeft: isMobile ? "14px" : "20px",
                                    //   marginRight: isMobile ? "14px" : "20px",
                                    //   paddingLeft: 0,
                                    //   paddingRight: 0
                                }
                                : {
                                    border: "none",
                                    outline: "none",
                                    background: "white",
                                    color: "#8C9196",
                                    fontSize: isMobile ? "unset" : getRemValue(14),
                                    letterSpacing: isMobile ? "unset" : getRemValue(0.16),
                                    boxShadow: "none"
                                    //   marginLeft: isMobile ? "14px" : "20px",
                                    //   marginRight: isMobile ? "14px" : "20px",
                                    //   paddingLeft: 0,
                                    //   paddingRight: 0
                                }, onClick: (e) => onClickPage(e, i + 1), id: `navigate-page-${i + 1}` }, i + 1))));
            }
            else {
                return null;
            }
        }),
        React__default.createElement(PaginationItem, { disabled: currentPage === pagesCount, style: { border: "none", outline: "none", marginLeft: isMobile ? "2px" : "8px" } },
            React__default.createElement(NextLink, null,
                React__default.createElement(PaginationLink, { onClick: onClickNext, next: true, style: { border: "none", outline: "none", boxShadow: "none" } }, currentPage === pagesCount ? (React__default.createElement("div", { style: {
                        height: isMobile ? "8px" : "12px",
                        width: isMobile ? "4.6px" : "6.91px",
                        alignItems: "center"
                    }, id: "navigate-next" },
                    React__default.createElement(SvgAngleLeftGray, null))) : (React__default.createElement("div", { style: {
                        height: isMobile ? "8px" : "12px",
                        width: isMobile ? "4.6px" : "6.91px",
                        alignItems: "center"
                    }, id: "navigate-next" },
                    React__default.createElement(SvgAngleLeft, null))))))));
};

export { Bottompagination as default };
//# sourceMappingURL=BottomPagination.js.map
